module.exports = __webpack_public_path__ + "static/media/CNY.180a069b.svg";